import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { createLocaleTextFunc, createTranslationsList } from '@/components/AgGrid/helpers/translations';

const useAgGridTranslations = () => {
  const intl = useIntl();

  const translations = useMemo(() => createTranslationsList(intl), [intl]);
  const getLocaleText = useMemo(() => createLocaleTextFunc(translations), [translations]);

  return {
    getLocaleText,
  };
};

export default useAgGridTranslations;
